import {
    ILogicState,
    InitLogicActionType,
    LogicActionTypes,
    UpdateLogicRequestActionType,
    UpdateLogicFailureActionType,
    UpdateLogicSuccessActionType,
} from "./types";
import { Handler } from "./../types/store-types";
import { toast } from "react-toastify";

const initLogic: Handler<ILogicState, InitLogicActionType> = (state, { payload }) => {
    const data = payload?.rules || [];
    return { ...state, data: { rules: data } };
};

const updateLogicRequest: Handler<ILogicState, UpdateLogicRequestActionType> = (state, { payload }) => {
    return { ...state };
};

const updateLogicSuccess: Handler<ILogicState, UpdateLogicSuccessActionType> = (state, { payload }) => {
    const data = payload.data;
    return { ...state, data: data };
};

const updateLogicFailure: Handler<ILogicState, UpdateLogicFailureActionType> = (state, { payload }) => {
    if (payload.error) toast.error("Something went wrong with Logic");
    return { ...state };
};

export const handlers = {
    [LogicActionTypes.INIT_LOGIC]: initLogic,
    [LogicActionTypes.UPDATE_LOGIC_REQUEST]: updateLogicRequest,
    [LogicActionTypes.UPDATE_LOGIC_SUCCESS]: updateLogicSuccess,
    [LogicActionTypes.UPDATE_LOGIC_FAILURE]: updateLogicFailure,
};
